import { IPagination } from '@/types';
import { Pagination, Select, Text } from '@shopify/polaris';
import { memo } from 'react';
import { PaginationStyled } from './styled';

interface IProps {
  pagination: IPagination;
  totalPage: number;
  handleChangePagination: (pagination: IPagination) => void;
  isLoading?: boolean;
}

const BasePagination = ({ pagination, totalPage, handleChangePagination, isLoading }: IProps) => {
  const options = [
    { label: '5', value: '5' },
    { label: '10', value: '10' },
    { label: '15', value: '15' },
    { label: '20', value: '20' },
  ];
  return (
    <PaginationStyled>
      <div />
      <Pagination
        label={isLoading ? '-/-' : `${pagination.page}/${totalPage}`}
        hasPrevious={isLoading ? false : pagination.page > 1}
        onPrevious={() => {
          handleChangePagination({ ...pagination, page: pagination.page - 1 });
        }}
        hasNext={isLoading ? false : pagination.page < totalPage}
        onNext={() => {
          handleChangePagination({ ...pagination, page: pagination.page + 1 });
        }}
      />
      <div className="wrap-perPage">
        <Text as="p">Showing </Text>
        <div className="mx-4">
          <Select
            label="Per page"
            labelHidden
            options={options}
            value={pagination.perPage.toString() || '5'}
            onChange={(value) => handleChangePagination({ ...pagination, perPage: +value, page: 1 })}
          />
        </div>
        <Text as="p"> per page</Text>
      </div>
    </PaginationStyled>
  );
};

export default memo(BasePagination);
